export const aciSkiTicket = {
    iconName: 'ski-ticket',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M2.349 4.93a1.79 1.79 0 011.265-.524h16.771a1.79 1.79 0 011.79 1.79v3.226a.5.5 0 01-.5.5 2.08 2.08 0 000 4.16.5.5 0 01.5.5v3.225a1.79 1.79 0 01-1.79 1.79H3.615a1.79 1.79 0 01-1.79-1.79v-3.225a.5.5 0 01.5-.5 2.08 2.08 0 100-4.16.5.5 0 01-.5-.5V6.196c0-.474.188-.93.524-1.265zm1.265.476a.79.79 0 00-.79.79v2.766a3.08 3.08 0 010 6.079v2.766a.79.79 0 00.79.79h16.771a.79.79 0 00.79-.79v-2.766a3.08 3.08 0 010-6.079V6.196a.79.79 0 00-.79-.79H3.615z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M9.871 8.297a.5.5 0 01.694-.139L12 9.115l1.435-.957a.5.5 0 01.554.832l-1.712 1.142a.5.5 0 01-.555 0L10.01 8.99a.5.5 0 01-.139-.693z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M12 6.934a.5.5 0 01.5.5v9.133a.5.5 0 01-1 0V7.434a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M11.722 13.87a.5.5 0 01.555 0l1.712 1.14a.5.5 0 11-.554.833L12 14.886l-1.435.957a.5.5 0 11-.555-.832l1.712-1.142zM15.702 9.873a.5.5 0 01.139.694l-.957 1.435.957 1.435a.5.5 0 01-.832.554l-1.142-1.712a.5.5 0 010-.555l1.142-1.712a.5.5 0 01.693-.139z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M6.934 12a.5.5 0 01.5-.5h9.133a.5.5 0 010 1H7.434a.5.5 0 01-.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M8.297 9.873a.5.5 0 01.693.139l1.142 1.712a.5.5 0 010 .555L8.99 13.99a.5.5 0 01-.832-.554l.957-1.435-.957-1.436a.5.5 0 01.139-.693z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
